import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

export class UserAlreadyExistsError extends CustomError {
	readonly userId: string;
	readonly userPasswordSet: boolean;

	constructor({ userId, userPasswordSet }: { userId: string; userPasswordSet: boolean }) {
		super('User already exists');
		this.userId = userId;
		this.userPasswordSet = userPasswordSet;
	}
}
setClassName(UserAlreadyExistsError, 'UserAlreadyExistsError');
